import axios from 'axios'
import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '../../helpers/methods'

let {getNested, deepCopy} = helpers

const API_PATH = `${config.appUrl}/api/settings/user-preferences`

// state
export const state = {}

// getters
export const getters = {
    preferences: state => (key) => {
        if (!key) return deepCopy(state)
        return getNested(key, state, '[UNDEFINED]') === '[UNDEFINED]' ? undefined : getNested(key, state)
    }
}

// mutations
export const mutations = {
    [types.FETCH_USER_PREFERENCES_SUCCESS](state, {key, value}) {
        let curr = state
        key.split('.').forEach((step, index, array) => {
            Vue.set(curr, step, index === array.length - 1 ? value : curr[step] || {})
            curr = curr[step]
        })
    },

    [types.FETCH_USER_PREFERENCES_FAILURE](state) {
        // ?
    },
}

// actions
export const actions = {
    async fetch({commit}, {key, defaultValue}) {
        try {
            const {data} = await axios.get(`${API_PATH}/${key}`)
            let {value} = data

            if (value === undefined) value = defaultValue

            commit(types.FETCH_USER_PREFERENCES_SUCCESS, {key, value})
        } catch (e) {
            commit(types.FETCH_USER_PREFERENCES_FAILURE)
        }
    },

    save({commit}, {key, value}) {
        commit(types.FETCH_USER_PREFERENCES_SUCCESS, {key, value})

        try {
            axios.patch(`${API_PATH}/${key}`, {value})
        } catch (e) {
        }
    }
}

export function userPreferences(path, defaultValue) {
    return {
        get() {
            let key = `${path}.${this.baseRoute}`
            let value = this.$store.getters['userPreferences/preferences'](key)
            if (value === undefined)
                this.$store.dispatch('userPreferences/fetch', {
                    key,
                    defaultValue
                })
            return value || defaultValue
        },

        set(value) {
            let key = `${path}.${this.baseRoute}`
            this.$store.dispatch('userPreferences/save', {
                key,
                value
            })
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/userPreferences.js